// extracted by mini-css-extract-plugin
export var linkText = "_ov-0";